const KENO_DRAWS_RANGE_OPTIONS = [    
    { "Id": 1, "Title": "1", "Value": 1 },
    { "Id": 2, "Title": "2", "Value": 2 },
    { "Id": 3, "Title": "3", "Value": 3 },
    { "Id": 4, "Title": "4", "Value": 4 },
    { "Id": 5, "Title": "5", "Value": 5 },
	{ "Id": 6, "Title": "10", "Value": 10 },
	{ "Id": 7, "Title": "20", "Value": 20 },
   
];

export default KENO_DRAWS_RANGE_OPTIONS;


// WEBPACK FOOTER //
// ./features/check-my-numbers/KENO_DRAWS_RANGE_OPTIONS.js